import { axiosInstance } from "./";

const createOffer = async (payload) =>
  await axiosInstance.post("/offers", payload);

const getOffers = async (params) =>
  await axiosInstance.get("/offers", { params });

const getOfferDetails = async (id) => await axiosInstance.get(`/offers/${id}`);

const deleteOffer = async (id) => await axiosInstance.delete(`/offers/${id}`);

const editOffer = async ({ id, data }) =>
  await axiosInstance.patch(`/offers/${id}`, data);

const getCallToActions = async (params) =>
  await axiosInstance.get("/call_to_actions", { params });

export {
  createOffer,
  getOffers,
  getOfferDetails,
  deleteOffer,
  editOffer,
  getCallToActions,
};
